export default __webpack_public_path__ + "static/media/memcached.1befaefe.svg";